export const SET_USER_ANONYMOUS_UUID = 'SET_USER_ANONYMOUS_UUID'

export function setAnonymousUuid (uuid) {
  return {
    type: SET_USER_ANONYMOUS_UUID,
    payload: { uuid },
  }
}
